// client/src/components/auth/profile/FloatingInput.js
import React, { useState } from 'react'
import './FloatingComponents.css'

function FloatingInput({
  label,
  name,
  value,
  onChange,
  type = 'text',
  required = false,
  disabled = false,
  onDisabledClick,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false)

  // Better hasValue logic that works for all input types including numbers
  const hasValue = value !== null && value !== undefined && value !== ''
  const isActive = isFocused || hasValue

  return (
    <div
      className={`floating-input-container ${
        disabled ? 'clickable-when-disabled' : ''
      }`}
      onClick={
        disabled && onDisabledClick
          ? (e) => {
              onDisabledClick(e)
            }
          : undefined
      }
      style={disabled ? { cursor: 'pointer' } : {}}
    >
      <input
        className={`floating-input ${required && !hasValue ? 'has-error' : ''}`}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
        style={disabled ? { pointerEvents: 'none' } : {}}
        {...props}
      />
      <label
        className={`floating-label ${isActive ? 'active' : ''} ${
          required ? 'required' : ''
        }`}
        style={disabled ? { pointerEvents: 'none' } : {}}
      >
        {label}
      </label>
    </div>
  )
}

export default FloatingInput
